import React from 'react';
import BoxStep from '../../../../components/common/BoxStep';
import { ShoppingCartItem } from '../../../../components/pages/basket/components/ShopingCartItem';
import { changeNumberOfSets } from '../../../../components/pages/basket/helpers/basketHelpers';
import { editItemInBasket } from '../../../../redux/actions/basketActions';
import { getPrice, getPricePerDay } from '../../../../utils/orderFormPrices';
import { useAppSelector } from '../../../../config/hooks';
import {
  getBasket,
  getFinalSumAfterDiscountAndDeliveryFee,
  getNumberOfItemsInTheBasket,
  getPromoCode,
} from '../../../../redux/selectors/basketSelector';
import AddAnotherDiet from './AddAnotherDiet';
import OneOffSideOrders from './OneOffSideOrders';
import LoyaltyPointsInfo from './LoyaltyPointsInfo';
import {
  getAddressDetails,
  getSelectedCity,
} from '../../../../redux/selectors/summaryReducer.selectors';
import { mealExchangeT } from '../../types/orderForm.type';
import { useEffectOnce } from 'react-use';
import { viewCartGA4 } from '../../../GA4/events/ecommerceEvents';
import { getServerConfig } from '../../../general/generalSlice';
import RecalculatePriceLoader from '../../stepSummary/views/RecalculatePriceLoader';
import useCalculateCartPrice from '../../../../services/hook/calculatePrices/useCalculateCartPrice.hook';

const ShoppingCartContent = () => {
  const { isFetching, prices } = useCalculateCartPrice();

  const basket = useAppSelector(getBasket);
  const numberOfSets = useAppSelector(getNumberOfItemsInTheBasket);
  const address = useAppSelector(getAddressDetails);
  const selectedCity = useAppSelector(getSelectedCity);
  const finalAmountToPayAfterDiscountsAndDeliveryFee = useAppSelector(
    getFinalSumAfterDiscountAndDeliveryFee
  );
  const { companyId, enhancedEcommerce } = useAppSelector(getServerConfig);
  const promoCode = useAppSelector(getPromoCode);
  const { code } = promoCode || {};
  const { city } = address || {};

  const checkIsCartHasMealExchange = (customOrderDays: mealExchangeT) =>
    Object.values(customOrderDays.days || {}).some(
      item => !!Object.values(item.mealsList || {}).length
    );

  useEffectOnce(() => {
    if (enhancedEcommerce && companyId) {
      viewCartGA4(
        basket,
        selectedCity,
        finalAmountToPayAfterDiscountsAndDeliveryFee
      );
    }
  });

  return (
    <div className="steps-page-basket__container">
      <BoxStep title="Zamówienie">
        <div className="position-rel">
          <RecalculatePriceLoader isFetching={isFetching} />

          {basket?.map(
            (
              item: {
                mealExchange: any;
                orderId: string;
                selectedProgram: string;
                sets: number;
                testOrder: boolean;
              },
              index: number
            ) => {
              const { mealExchange, orderId, selectedProgram, testOrder } =
                item || {};

              const totalPrices = prices?.items[item.orderId];

              return (
                <div key={orderId}>
                  <ShoppingCartItem
                    changeNumberOfSets={changeNumberOfSets}
                    editItemInBasket={editItemInBasket}
                    item={item}
                    itemPrice={getPrice(item, code, city?.sectorId)}
                    key={orderId}
                    lastItem={index === basket?.length - 1}
                    mealExchange={checkIsCartHasMealExchange(mealExchange)}
                    numberOfSets={numberOfSets}
                    pricePerDay={getPricePerDay(
                      item,
                      code,
                      city?.sectorId,
                      selectedProgram === 'menuConfiguration'
                    )}
                    testOrder={testOrder}
                    totalPrices={totalPrices}
                  />
                </div>
              );
            }
          )}

          <AddAnotherDiet />
        </div>

        <div className="steps-page__divide spacer-bottom-40 hidden-down-lg" />
        <OneOffSideOrders />
        <LoyaltyPointsInfo />
      </BoxStep>
    </div>
  );
};

export default ShoppingCartContent;
